<div class="topTitle">The Talker AAC</div>
<Link href="/" cssClass="homeBtn">🏠</Link>
<Link href="/about.html" cssClass="cheat">about us</Link>
<nav >
  <ul>
	{#each cats as cat}
	  {#if cat[0]== 'home'}
	  <li data-id="{cat[0]}"><a href="/">{cat[1].menu}</a></li>
	  {:else}
	  <li data-id="{cat[0]}"><a href="/{cat[0]}.html">{cat[1].menu}</a></li>
	  {/if}
	   
	{/each}
  </ul>
</nav>

<style>
	aside {
		padding: .6rem;
		color: ivory;
		font-family: 'Luckiest Guy', cursive;
		font-size: 2.3rem;
		letter-spacing: 2px;
		word-spacing: 10px;
		text-shadow: -1px -1px 1px black
	}
	.menu-list, .menu-label, a{
		
	}
 
</style>

<script>


import roadtrip from 'roadtrip';
//on:click="goto(`snippets/${x}`)"
//const baseUrl = 'http://localhost:5100';

import Link from './Link.html';
const catsData = {
	  "home": {
			"menu": "About the Talker",
			"desc": "Our custom AAC solution, including 8 inch tablet, case, carrying bag, and pre-installed software from Tobii Dynavox.",
			"img": "",
			"tips": ["8 inch touchscreen Dell tablet", 
			"Snap Core First AAC Software by Tobii Dynavox", 
			"Durable cases & carrying bags"],
			"syntax": "",
			"post": ""
		},
	"aac_software": {
			"menu": "AAC Software",
			"desc": "Screenshots and information about the AAC Software by Tobii Dynavox.",
			"img": "",
			"tips": ["Great visual presentation of symbols", 
			"Easy for kids to use", 
			"Quick customization and syncing"],
			"syntax": "",
			"post": ""
		},
		"tablet": {
			"menu": "Dell 8 Inch Tablet",
			"desc": "Details about the Dell Venue Pro 8 tablet as a dedicated speech device.",
			"img": "",
			"tips": ["Perfect size for a portable personal device", 
			"Great sound", 
			"Modified to use as a dedicated speech device"],
			"syntax": "",
			"post": ""
		},
		"cover": {
			"menu": "Tough covers",
			"desc": "Details about The Talker's covers, chosen to withstand aggressive use by children!",
			"img": "",
			"tips": ["Protecting tablet from drops", 
			"Protecting from spills", 
			"Stands for working with tablet"],
			"syntax": "",
			"post": ""
		},			
		"carrying": {
			"menu": "Neoprene Carrying Case",
			"desc": "Details about The Talker's carrying cases, intended to be colorful and easy for kids to carry themselves.",
			"img": "",
			"tips": ["Made of protective neoprene", 
			"Colorful, fun designs kids like", 
			"Soft handles to encourage the child to carry it themselves"],
			"syntax": "",
			"post": ""
		},	
		"listings": {
			"menu": "Price & Buy Now",
			"desc": "Current listings for the Talker along with the prices",
			"img": "",
			"tips": ["Where to Buy", 
			"Prices", 
			"Current Items for Sale"],
			"syntax": "",
			"post": ""
		},	
		"icons": {
			"menu": "AAC Graphics",
			"desc": "Custom AAC Graphics and icons we've developed as building blocks to language development & literacy.",
			"img": "",
			"tips": ["Building blocks for language", 
			"Simple & understandable", 
			"Moving towards literacy"],
			"syntax": "",
			"post": ""
		},	
		"activities": {
			"menu": "AAC Activities",
			"desc": "AAC activity ideas, downloadable page sets, lesson plans, and more.",
			"img": "",
			"tips": ["AAC vocabulary building", 
			"Goal oriented activities", 
			"Literacy building"],
			"syntax": "",
			"post": ""
		},			
}

// let cats = [];
//   for (let cat in catsData) {
//   cats.push({id: cat, ...catsData[cat]});
// }
// you don't need to do map AND entries - just 1 will do!! Just use [0] for the key, [1] for the value
 let cats = Object.entries(catsData);

//console.log('cats are now '+JSON.stringify(cats))
 //each Object.entries(obj) and each [...iterable].

  export default {
    data() {
	return { 
		snippets: [],
		sectionColors: [],
		cats: cats,
	 }
	},
	components: {Link
	},
 	onstate({ changed, current, previous }) {
			// this fires before oncreate, and on every state change.
			// the first time it runs, `previous` is undefined
			if (changed.snippets) {
				console.log('hey snippets have changed');
			}
	},
    oncreate() {

			/* get the colors for each menu item to use in their section */
			let sections = document.querySelectorAll('nav > ul > li > a');
			let sectionColors = {};
			for (let element of sections) {
				const id = element.parentNode.getAttribute('data-id');
				const color1 = window.getComputedStyle(element).borderLeftColor;
				const color2 = window.getComputedStyle(element,':after').backgroundColor;
				sectionColors[id] = {color1,color2};
			}
    	store.set({ cats:cats, sectionColors:sectionColors });
	},
    methods: {
      goto(path) {
        roadtrip.goto(path);
      }
    }
  }
</script>